// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1bN_f","image":"App_image__35PWt"};